












import { Vue, Prop, Component } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import InfoTooltip from '@/components/common/InfoTooltip.vue';
import Button from '@/components/common/inputs/Button.vue';
import Toggle from '@/components/common/inputs/Toggle.vue';
import { ProcessState, ProcessModule } from '@/store/modules/process';

@Component({
  components: {
    Toggle,
    InfoTooltip,
    Button
  }
})
export default class ProcessHeader extends Vue {
  @Prop(Boolean)
  isReporting!: boolean;
  @Prop(Boolean)
  isUmbrella!: boolean;

  get state() {
    return ProcessModule;
  }

  async copy() {
    const id = await ProcessModule.copyProcess();
    this.$router.push(`/details/${id}`);
  }

  async remove() {
    if (confirm('このプロセスを完全に削除しますか？')) {
      await ProcessModule.removeProcess();
      this.$router.push(`/search`);
    }
  }
}
